module.exports = __webpack_public_path__ + "img/ta_report_t.9954809f.png";